import { Box } from '@chakra-ui/react'
import MyCollaboratory from '../../components/PatientsBox/MyCollaboratory'

export default function CollaboratoryPage() {
  return (
    <Box
      p={{
        base: '32px 16px',
        lg: '32px 100px',
        xl: '32px 200px',
        '2xl': '32px 300px',
      }}
      h={'100%'}
    >
      <MyCollaboratory />
    </Box>
  )
}
